import {Client} from '@apps-common/auth';
import {AUTH} from '@src/config.ts';

export const authClient = new Client({
  clientId: AUTH.clientId,
  issuer: AUTH.issuer,
  redirectUri: `${window.location.origin}${import.meta.env.BASE_URL}`,
  postLogoutRedirectUri: `${window.location.origin}${import.meta.env.BASE_URL}`,
});
